import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@components/shared/forms';
import { CustomIcon } from '@components/shared';
import { components } from 'react-select';
import InterSvg from './inter.svg';
import RobotoSvg from './roboto.svg';
import OpenSansSvg from './open-sans.svg';
import MontserratSvg from './montserrat.svg';
import LatoSvg from './lato.svg';
import PoppinsSvg from './poppins.svg';
import SourceSansProSvg from './source-sans-pro.svg';
import RalewaySvg from './raleway.svg';
import NotoSansSvg from './noto-sans.svg';
import RobotoSlabSvg from './roboto-slab.svg';
import MerriweatherSvg from './merriweather.svg';
import PlayfairDisplaySvg from './playfair-display.svg';

const fonts = [
  {
    value: 'Inter',
    label: 'Inter',
    Icon: InterSvg,
  },
  {
    value: 'Lato',
    label: 'Lato',
    Icon: LatoSvg,
  },
  {
    value: 'Merriweather',
    label: 'Merriweather',
    Icon: MerriweatherSvg,
  },
  {
    value: 'Montserrat',
    label: 'Montserrat',
    Icon: MontserratSvg,
  },
  {
    value: 'Noto Sans',
    label: 'Noto Sans',
    Icon: NotoSansSvg,
  },
  {
    value: 'Open Sans',
    label: 'Open Sans',
    Icon: OpenSansSvg,
  },
  {
    value: 'Playfair Display',
    label: 'Playfair Display',
    Icon: PlayfairDisplaySvg,
  },
  {
    value: 'Poppins',
    label: 'Poppins',
    Icon: PoppinsSvg,
  },
  {
    value: 'Raleway',
    label: 'Raleway',
    Icon: RalewaySvg,
  },
  {
    value: 'Roboto',
    label: 'Roboto',
    Icon: RobotoSvg,
  },
  {
    value: 'Roboto Slab',
    label: 'Roboto Slab',
    Icon: RobotoSlabSvg,
  },
  {
    value: 'Source Sans Pro',
    label: 'Source Sans Pro',
    Icon: SourceSansProSvg,
  },
];

const Option = ({ ...props }: any) => {
  const { Icon } = props.data;

  useEffect(() => {
    const svg = document.getElementById(`${props.data.label}-svg`) as SVGAElement | null;
    if (svg) {
      const bbox = svg.getBBox();
      const modifier = 16 / bbox.height;
      svg.setAttribute('width', `${bbox.width * modifier}`);
      svg.setAttribute('height', `${bbox.height * modifier}`);
    }
  });
  return (
    <components.Option {...props}>
      <div className="flex justify-between">
        <Icon id={`${props.data.label}-svg`} />
        {props.isSelected ? <CustomIcon type="checkmark" className="!text-black-100" /> : null}
      </div>
    </components.Option>
  );
};

export default function FontPicker() {
  const { t } = useTranslation('admin');

  return (
    <Select
      name="font"
      options={fonts}
      labelText={t('microsite.font.title')}
      required
      data-testid="font-selector"
      containerClass="!mb-0 w-full"
      isClearable={false}
      components={{ Option }}
      styles={{
        option: provided => ({
          ...provided,
          backgroundColor: 'white',
        }),
      }}
    />
  );
}
